/**
 * Helpers for extracting coordinates from SWTOR combat-log lines.
 *
 * SWTOR source-entity brackets look like:
 *   [@CharacterName#123456789|(-148.89,-46.09,-0.41,-67.46)|(3244/3244)]
 * where the parenthesised group after the name is (x, y, z, facing).
 *
 * Used by the admin image-library upload form to auto-fill coordinates from a
 * pasted Seismic Excavator/Scanner log line, mirroring the electron client's
 * SOURCE_ENTITY parser.
 */
/**
 * Matches the source-entity position group: `@name#id|(x,y,z,facing)`.
 * The optional `(?:\/[^|]*)?` swallows companion-attribution suffixes.
 */
const SOURCE_ENTITY_COORDS = /@[^#|\]]+#\d+(?:\/[^|]*)?\|\(?(-?[\d.]+),(-?[\d.]+),(-?[\d.]+),(-?[\d.]+)\)?/;
/** Fallback: any parenthesised 4-number group `(x,y,z,facing)`. */
const BARE_COORDS = /\(?(-?[\d.]+),(-?[\d.]+),(-?[\d.]+),(-?[\d.]+)\)?/;
/**
 * Extract `(x, y, z, facing)` from a pasted combat-log line (or coordinate
 * string). Returns null if no coordinate group is found.
 */
export function extractCoordsFromLogLine(line) {
    if (!line)
        return null;
    const match = SOURCE_ENTITY_COORDS.exec(line) ?? BARE_COORDS.exec(line);
    if (!match)
        return null;
    const [, x, y, z, facing] = match;
    const parsed = {
        x: Number(x),
        y: Number(y),
        z: Number(z),
        facing: Number(facing),
    };
    if (Number.isNaN(parsed.x) ||
        Number.isNaN(parsed.y) ||
        Number.isNaN(parsed.z) ||
        Number.isNaN(parsed.facing)) {
        return null;
    }
    return parsed;
}
